import * as React from 'react';
import { compose } from 'redux';

import { titleCase } from '@acceligentllc/shared/utils/text';

import type { CalculatedReportDisplayStatus } from '@acceligentllc/shared/enums/reportDisplayStatus';
import { CalculatedReportDisplayStatusLabels } from '@acceligentllc/shared/enums/reportDisplayStatus';

import AdditionalFilter from 'af-components/Table/Filters/AdditionalFilter/Multiselect';

import DisplayReviewStatusLabel from '../../../Shared/DisplayReviewStatusLabel';

export interface ReviewStatusFilterOption {
	id: string;
	label: string;
}

interface OwnProps {
	onChange: (options: ReviewStatusFilterOption[]) => void;
	selected: ReviewStatusFilterOption[];
	forBulkModal?: boolean;
	onClear?: () => void;
	autoOpen?: boolean;
}

type Props = OwnProps;

const options = Object.keys(CalculatedReportDisplayStatusLabels).map((key) => ({ id: key, label: titleCase(CalculatedReportDisplayStatusLabels[key]) }));

const ReviewStatusFilter: React.FC<Props> = (props) => {

	const {
		onChange,
		selected,
		forBulkModal,
		onClear,
		autoOpen,
	} = props;

	const renderOption = React.useCallback((option: ReviewStatusFilterOption) => {
		return (
			<DisplayReviewStatusLabel
				calculatedReportDisplayStatus={option.id as CalculatedReportDisplayStatus}
				isCondensedView={false}
				isForDropdown={true}
				isOfInterest={false}
			/>
		);
	}, []);

	const onValueChange = React.useCallback((_options: ReviewStatusFilterOption[]) => {
		onChange(_options);
	}, [onChange]);

	return (
		<AdditionalFilter
			autoOpen={!!autoOpen}
			filterName="Review Status"
			forBulkModal={!!forBulkModal}
			onChange={onValueChange}
			onRemoveFilter={onClear}
			options={options}
			renderOptionOverride={renderOption}
			selected={selected}
		/>
	);
};

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo
);

export default enhance(ReviewStatusFilter);
